<template>
  <div class="grid-container full container">
    <div class="grid-x" >
      <div class="small-12 medium-7 cell small-text-center left-column">
        <h1 v-if="isHeader">Candid ATS</h1>
        <h2 v-else>Candid ATS</h2>
        <p class="tag">
          Beautiful, intuitive interface. <span class="no-line-break">Ground-breaking</span> analytics. <span class="no-line-break">World-class</span> security.
        </p>

        <rare-standard-button
          class="contactButton show-for-small-only"
          :tabIndex="13"
          :active="'true'"
          :buttonText="buttonLabel"
          :height="'40px'"
          :width="'200px'"
          :fontColor="'#ffffff'"
          :fontSize="'14px'"
          @clicked="handleButtonClick()"
        />
        <rare-standard-button
          class="contactButton show-for-medium"
          :tabIndex="13"
          :active="'true'"
          :buttonText="buttonLabel"
          :height="'75px'"
          :width="'316px'"
          :fontColor="'#ffffff'"
          :fontSize="'20px'"
          @clicked="handleButtonClick()"
        />

      </div>
      <div class=" small-12 medium-5 cell right-column page-contents-8-right hide-for-small-only">
        &nbsp;
      </div>
      <div class="small-12 cell text-center show-for-small-only small-mbp-2">
        &nbsp;
      </div>

    </div>
  </div>
</template>
<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'RareHomeProductsCandidAts',
  props: {
    isHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      buttonLabel: '',
    };
  },
  components: {
    'rare-standard-button': RareStandardButton,
  },
  mounted() {
    this.buttonLabel = this.isHeader === true ? 'Get in touch' : 'Learn more';
  },
  methods: {
    handleButtonClick() {
      if (this.isHeader) {
        this.$emit('jumpToForm');
      } else {
        this.$router.push('/products/candid-ats');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .no-line-break {
    white-space: nowrap;
  }

  .container {
    border-bottom: 1px solid $border;
  }

  .full {
    background-image: url("../../../assets/img/backgrounds/candid-mbp-small-2.jpeg");
    background-repeat: no-repeat;
    background-position: 125% 50px;
    background-size: 55%;
  }

  @media only screen and (min-width: 900px) and (max-width: 1030px) {
    .full {
      background-position: right;
    }
  }
  @media only screen and (min-width: 680px) and (max-width: 900px) {
    .full {
      background-position: -300px 112px;
    }
  }
  @media only screen and (min-width: 641px) and (max-width: 680px) {
    .full {
      background-position: -350px 112px;
    }
  }
  @media only screen and (max-width: 641px) {
    .full {
      background-image: none;
    }
  }

  .small-mbp-2 {
    background-image: url("../../../assets/img/backgrounds/candid-mbp-small-2.jpeg");
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 70%;
    height: 251px;
    margin-bottom: 30px;
  }


  p.tag {
    color: $main-text;
  }

  h2, h1 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }


  @media only screen and (max-width: 640px) {
    .page-contents-8-right {
      padding: 0 8.6% !important;
    }

    .left-column {
      padding: 0 30px 0 20px;
    }

    .tag {
      text-align: center;
      font-size: 20px;
      line-height: 30px;
    }

    h2, h1 {
      font-size: 28px;
      line-height: 1.43;
      margin: 28px 0 18px 0;
      text-align: center;
    }

    .contactButton {
      margin: 25px auto 25px auto;
    }
  }

  @media only screen and (min-width: 641px) {
    .contactButton {
      margin: 48px 0 160px 0;
    }

    .left-column {
      padding-left: 8.6%;
    }

    .tag {
      font-size: 30px;
    }

    h2, h1 {
      font-size: 56px;
      line-height: 1.29;
      margin: 96px 0 33px 0;
      text-align: left;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/components/RareHomeProductsCandidAts.vue